module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "trial-lockout-overlay",
    style: (_vm.overlayStyle)
  }, [_c('div', {
    staticClass: "trial-lockout-modal",
    attrs: {
      "role": "dialog",
      "aria-labelledby": "canceled-lockout-title"
    }
  }, [_c('div', {
    staticClass: "trial-lockout-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('svg', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5",
      "viewBox": "0 0 24 24"
    }
  }, [_c('rect', {
    attrs: {
      "x": "3",
      "y": "11",
      "width": "18",
      "height": "11",
      "rx": "2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M7 11V7a5 5 0 0110 0v4"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "trial-lockout-title",
    attrs: {
      "id": "canceled-lockout-title"
    }
  }, [_vm._v(_vm._s(_vm.copy.title))]), _vm._v(" "), _c('p', {
    staticClass: "trial-lockout-sub",
    domProps: {
      "innerHTML": _vm._s(_vm.copy.messageHtml)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "trial-lockout-foot"
  }, [_c('a', {
    attrs: {
      "href": "mailto:support@sentrykit.com?subject=SentryKit%20subscription%20reactivation"
    }
  }, [_vm._v("Contact support")]), _vm._v("\n      ·\n      "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.signOut
    }
  }, [_vm._v("Log out")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8c9e3ade!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buybox/CanceledLockoutOverlay.vue
// module id = 803
// module chunks = 2